import { render, staticRenderFns } from "./ViewerPage.vue?vue&type=template&id=265c10dd&scoped=true"
import script from "./ViewerPage.vue?vue&type=script&lang=js"
export * from "./ViewerPage.vue?vue&type=script&lang=js"
import style0 from "./ViewerPage.vue?vue&type=style&index=0&id=265c10dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c10dd",
  null
  
)

export default component.exports